import { type AdminSuretyBond, useAdminFetchBond } from "@portal/api/bond/admin";
import { useFetchRecentlyUsedSfaaCodes } from "@portal/api/sfaa-code/admin";
import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { useRecentlyViewedEntities } from "@portal/hooks/useRecentlyViewed";
import { useEffect } from "react";
import { withErrorBoundary } from "react-error-boundary";
import { useNavigate, useParams } from "react-router-dom";
import { AdminBondPageLayout } from "./tabbed/AdminBondPageLayout";

const AdminBondViewCore = ({ bond }: { bond: AdminSuretyBond }) => {
	const { addRecentlyViewedEntity } = useRecentlyViewedEntities();
	useFetchRecentlyUsedSfaaCodes(bond.accountId, { suretyType: bond.suretyType });

	useEffect(() => {
		addRecentlyViewedEntity({ id: bond.id, entityType: "bond" });
	}, [bond.id, addRecentlyViewedEntity]);

	return <AdminBondPageLayout bond={bond} />;
};

const AdminBondViewContainer = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { bond, bondError, bondLoading } = useAdminFetchBond(id!);

	useEffect(() => {
		if (bondError) {
			navigate("/bonds");
		}
	}, [bondError, navigate]);

	if (bondLoading || bond === undefined) return <LoadingModal />;
	return <AdminBondViewCore bond={bond} />;
};

export const AdminBondView = withErrorBoundary(AdminBondViewContainer, {
	fallback: <div>Something went wrong</div>,
});
